import { FC } from "react";
import { decode } from "html-entities";
import DOMPurify from 'dompurify';
import './html.scss';

interface IHtmlRender {
  content: any;
  sliceLength?: number;
}

const HtmlRender: FC<IHtmlRender> = ({ content, sliceLength, ...props }) => {
  const sanitizedContent = DOMPurify.sanitize(content);
  return (
    <p
      {...props}
      dangerouslySetInnerHTML={{
        __html:
          sliceLength && content.length > sliceLength
            ? sanitizedContent.slice(0, sliceLength) + ".."
            : decode(sanitizedContent),
      }}
    ></p>
  );
};

export default HtmlRender;
